import { Center, Spinner } from '@chakra-ui/react';

export const Loading = () => (
  <Center w="100%" h="100%" p={4}>
    <Spinner thickness="4px" emptyColor="gray.200" color="blue.500" size="lg" />
  </Center>
);
